import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { HttpModule } from '@angular/http';
import { FormsModule } from "@angular/forms";
import { CabeceraModule } from "../../../components/common/cabecera/cabecera.module";
import { DataTableModule } from "angular2-datatable";
import { Ng2Bs3ModalModule } from "ng2-bs3-modal/ng2-bs3-modal";
import { Ng2Webstorage } from "ngx-webstorage/dist/app";
import { PolizasContratadas } from "./polizas-contratadas.component";
import { PolizasContratadasService } from "./polizas-contratadas.service";
import { AplicacionesTransporteModule } from "../aplicacionesTransporte/aplicaciones-transporte.module";
import { SolicitudVehiculosModule } from "../solicitudes/solicitud-vehiculos.module";
import { SolicitudEquiposModule } from "../solicitudes/solicitud-equipo.module";
import { SolicitudOtrosModule } from "../solicitudes/solicitud-otros.module";
import { PolizasVencidasNoLiberadasService } from "../fianzas/polizasVencidasNoLiberadas/polizas-vencidasnoLiberadas.service";
import { RedesEmpresaModule } from "../vamEmpresa/redes/redesEmpresa.module";
import { CondicionesVamModule } from "../vamEmpresa/condiciones/condiciones.module";
import { SiniestralidadEmpresaModule } from "../vamEmpresa/siniestralidad/siniestralidad.module";
import { MovimientosVamModule } from "../vamEmpresa/movimientos/movimientosVam.module";
import { ListadosModule } from "../vamEmpresa/listados/listados.module";
import { SolicitudMovimientosModule } from "../vamEmpresa/solicitudes/solicitudes-movimientos.module";
import { UtilService } from "../../../components/common/utils/util.service";
import { ApplicationPipesModule } from "../../../components/pipes/safe.module";

@NgModule({
    declarations: [PolizasContratadas],
    imports: [
        BrowserModule,
        HttpModule,
        FormsModule,
        CabeceraModule,
        DataTableModule,
        Ng2Bs3ModalModule,
        Ng2Webstorage,
        AplicacionesTransporteModule,
        SolicitudVehiculosModule,
        SolicitudEquiposModule,
        SolicitudOtrosModule,
        RedesEmpresaModule,
        CondicionesVamModule,
        SiniestralidadEmpresaModule,
        ListadosModule,
        MovimientosVamModule,
        SolicitudMovimientosModule,
        ApplicationPipesModule
      ],
    providers: [PolizasContratadasService,PolizasVencidasNoLiberadasService,UtilService]
})

export class PolizasContratadasModule { }



// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/empresas/polizasContratadas/polizas-contratadas.module.ts